import { PayrollReportSummaryStatus } from '@iota/inh-core-v1-management-client';
import { PayrollReportSummaryEntity } from 'src/app/store/entity-models';
import { isoDateDaysAgo } from 'src/app/shared/utils/date.util';

export function payrollReportDefaultDateFrom(): string {
    return isoDateDaysAgo(20);
}

export const PayrollReportSummaryStatusToThemeColor: Partial<Record<PayrollReportSummaryStatus, string>> = {
    [PayrollReportSummaryStatus.TO_BE_REVIEWED]: 'bg-iota-requested text-yellow-700',
    [PayrollReportSummaryStatus.REVIEWED_AND_APPROVED]: 'bg-iota-inh-green text-white',
    [PayrollReportSummaryStatus.REVIEWED_AND_REJECTED]: 'bg-iota-rejected text-red-700',
    [PayrollReportSummaryStatus.GENERATION_FAILED]: 'bg-iota-rejected text-red-700'
};
export const PayrollReportSummaryStatusLabels: Partial<Record<PayrollReportSummaryStatus, string>> = {
    [PayrollReportSummaryStatus.TO_BE_REVIEWED]: $localize`:@@newSingular:New`,
    [PayrollReportSummaryStatus.REVIEWED_AND_APPROVED]: $localize`Approved`,
    [PayrollReportSummaryStatus.REVIEWED_AND_REJECTED]: $localize`Rejected`,
    [PayrollReportSummaryStatus.GENERATION_FAILED]: $localize`Failed`
};

export enum PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER {
    ALL = 'ALL',
    FAILED = 'FAILED',
    REJECTED = 'REJECTED',
    APPROVED = 'APPROVED'
}

export const PayrollReportSummaryFilterLabels: { [K in PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER]: string } = {
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.ALL]: $localize`All`,
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.APPROVED]: $localize`Approved`,
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.REJECTED]: $localize`Rejected`,
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.FAILED]: $localize`Failed`
};

export type PayrollReportSummaryProperties = Partial<Record<keyof PayrollReportSummaryEntity, string>>;

export const PayrollReportSummaryKeyLabels: Required<PayrollReportSummaryProperties> = {
    id: $localize`ID`,
    companyId: $localize`Company ID`,
    companyName: $localize`Company`,
    companyNumber: $localize`Company no.`,
    report: $localize`Report`,
    reportFromDate: $localize`Report from`,
    reportToDate: $localize`Report to`,
    documentId: $localize`Document ID`,
    status: $localize`Status`,
    errorMessage: $localize`Error`,
    fullErrorLog: $localize`Error log`,
    creationDateTime: $localize`Creation date`,
    notes: '',

    companyDetailsUrl: $localize`Company URL`,
    noteEntries: $localize`Notes`,
    canBeRejectedAndApproved: '',
    hasFailedStatus: '',
    hasAtLeastOneNote: ''
};

export const DEFAULT_PAYROLL_REPORT_SUMMARY_OVERVIEW_TABLE_HEADERS: (keyof PayrollReportSummaryProperties)[] = [
    'creationDateTime',
    'reportFromDate',
    'reportToDate',
    'companyNumber',
    'companyName',
    'status'
];

export const PayrollReportSummaryOverviewTableHeaders: {
    [K in PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER]: (keyof PayrollReportSummaryProperties)[];
} = {
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.ALL]: DEFAULT_PAYROLL_REPORT_SUMMARY_OVERVIEW_TABLE_HEADERS,
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.APPROVED]: DEFAULT_PAYROLL_REPORT_SUMMARY_OVERVIEW_TABLE_HEADERS,
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.REJECTED]: DEFAULT_PAYROLL_REPORT_SUMMARY_OVERVIEW_TABLE_HEADERS,
    [PAYROLL_REPORT_SUMMARY_OVERVIEW_FILTER.FAILED]: ['creationDateTime', 'companyNumber', 'companyName', 'errorMessage']
};

export const PAYROLL_REPORT_SUMMARY_IDS: (keyof PayrollReportSummaryProperties)[] = ['id', 'companyId', 'documentId'];

export const PAYROLL_REPORT_SUMMARY_DATE_PROPERTIES: (keyof PayrollReportSummaryProperties)[] = [
    'creationDateTime',
    'reportFromDate',
    'reportToDate'
];
